<template>
    <div class="animated fadeIn">
        <div v-if="!dataEntryMode" class="viewMode">
            <b-row>
                <b-col cols="12">
                    <h1>Desktop App Releases</h1>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-card>
                        <div slot="header">
                            <strong>Releases</strong>
                        </div>
                        <div v-if="!releasesLoaded" class="form-container">
                            <LoadingSpinner />
                        </div>
                        <div v-if="releasesLoaded" class="form-container">
                            <b-row v-if="!isUserReadOnly">
                                <b-col cols="12" sm="12" md="6">
                                    <p>
                                        <b-button v-on:click="enterAddMode" variant="primary">
                                            <i class="fa fa-plus"></i>&nbsp;Add Release
                                        </b-button>
                                    </p>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col v-for="release in releases" cols="12" sm="12" md="6" v-bind:key="release.id">
                                    <b-card :no-body="true" footer-class="px-3 py-2">
                                        <b-card-body class="p-3 clearfix">
                                            <img src="/img/pp-icon-login.png" width="64px" class="mr-3 float-left" />
                                            <div>
                                                <span class="h5 text-warning mb-0">
                                                    {{release.version}}
                                                </span>
                                                <span v-if="release.is_current != true" class="text-muted text-uppercase font-weight-bold">
                                                    <span :class="getClassForRelease(release)">Inactive Version</span>
                                                </span>
                                            </div>
                                            <div>
                                                <b-button v-if="!release.is_current" class="toggle-release-button" variant="outline-primary" @click="confirmSetLiveVersion(release.id)">
                                                    {{release.is_current == true ? 'Set as Inactive Version' : 'Set to Live Version'}}
                                                </b-button>
                                                <span v-if="release.is_current == true" class="text-muted text-uppercase font-weight-bold">
                                                    <span :class="getClassForRelease(release)">Current LIVE Version</span>
                                                </span>
                                            </div>
                                        </b-card-body>
                                        <div slot="footer">
                                            <b-link class="font-weight-bold font-xs btn-block text-muted" @click="enterEditMode(release)">View Release Notes <i class="fa fa-angle-right float-right font-lg"></i></b-link>
                                        </div>
                                    </b-card>
                                </b-col>
                            </b-row>
                        </div>
                    </b-card>
                </b-col>
            </b-row>
        </div>
        <div v-if="dataEntryMode" class="addMode">
            <b-row>
                <b-col cols="12">
                    <b-button v-on:click="exitAddMode" variant="secondary">
                        <i class="fa fa-arrow-circle-left"></i>&nbsp;Back
                    </b-button>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12">
                    <h1>Add New Desktop Release</h1>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-card>
                        <div slot="header">
                            <strong>Release Details</strong>
                        </div>
                        <div class="form-container">
                            <b-row>
                                <b-col sm="9">
                                    <b-form-group>
                                        <label for="releaseVersion">Version</label>
                                        <b-form-input v-model="release.version" type="text" id="releaseVersion"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="3">
                                    <b-form-group>
                                        <label for="releaseIsCurrent">Current Version</label><br/>
                                        <b-button 
                                            class="toggle-option-button" 
                                            :variant="getClassForReleaseButton(release)"
                                            @click="confirmSetLiveVersion(release.id)"
                                        >
                                            <span v-if="release.is_current">Yes</span><span v-else>No</span>
                                        </b-button>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <hr />
                            <b-row>
                                <b-col cols="12" sm="12" md="12">
                                    <p>
                                        <b-button v-on:click="saveRelease" variant="primary" :disabled="!allowSave">
                                            <i class="fa fa-check"></i>&nbsp;Save Release
                                        </b-button>&nbsp;
                                        <b-button v-if="addMode" v-on:click="saveReleaseAndAddNotes" variant="primary" :disabled="!allowSave">
                                            <i class="fa fa-check"></i>&nbsp;Save Release and Add Release Notes
                                        </b-button>
                                        <b-button v-if="editMode" v-on:click="deleteRelease" variant="danger" :disabled="!allowSave">
                                            <i class="fa fa-trash"></i>&nbsp;Delete Release
                                        </b-button>
                                    </p>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="12" sm="12" md="12">
                                    <b-alert v-if="releaseSaveError" variant="danger" show><strong>Error saving data. Please try again.</strong></b-alert>
                                    <b-alert v-if="releaseSaveInProgress" variant="info" show><strong>Saving data. Please wait...</strong></b-alert>
                                </b-col>
                            </b-row>
                        </div>
                    </b-card>
                </b-col>
            </b-row>
            <b-row v-if="editMode">
                <b-col sm="12">
                    <b-card>
                        <div slot="header">
                            <strong>Release Notes</strong>
                        </div>
                        <div class="form-container">
                            <b-row>
                                <b-col sm="10">
                                    <div class="mb-3">
                                        <strong>Release Note Entry</strong>
                                    </div>
                                </b-col>
                                <b-col sm="2">
                                    <div class="mb-3">
                                        <strong>Actions</strong>
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row v-for="note in release.release_notes" v-bind:key="note.id" class="output-row">
                                <b-col sm="10">
                                    <b-input-group>
                                        <b-form-input
                                        v-model="note.release_note"
                                        type="text"
                                        class="form-control"
                                        :id="'note-' + note.id + '-'"
                                        ></b-form-input>
                                    </b-input-group>
                                </b-col>
                                <b-col sm="2">
                                    <b-button
                                        v-if="note.id > 0" 
                                        variant="danger" 
                                        v-on:click="deleteNote(note)"
                                        :disabled="newNoteAddMode"
                                        class="mr-5x"
                                        >
                                        <i class="fa fa-trash"></i>
                                    </b-button>
                                    <b-button
                                        v-if="note.id < 0" 
                                        variant="primary" 
                                        v-on:click="cancelNoteEntry(note)"
                                        class="mr-5x"
                                        >
                                        <i class="fa fa-times"></i>
                                    </b-button>
                                    <b-button
                                        v-if="note.id < 0" 
                                        variant="success" 
                                        v-on:click="saveNewNote(note)"
                                        :disabled="note.release_note.length < 1"
                                        >
                                        <span v-if="!releaseNoteUpdating"><i class="fa fa-check"></i></span>
                                        <span v-if="releaseNoteUpdating && note.id != selectedReleaseNoteForAction"><i class="fa fa-check"></i></span>
                                        <span v-if="releaseNoteUpdating && note.id == selectedReleaseNoteForAction"><i class="fa fa-spin fa-spinner"></i></span>
                                    </b-button>
                                    <b-button
                                        v-if="note.id > 0" 
                                        variant="success" 
                                        v-on:click="updateNote(note)"
                                        :disabled="newNoteAddMode"
                                        >
                                        <span v-if="!releaseNoteUpdating"><i class="fa fa-check"></i></span>
                                        <span v-if="releaseNoteUpdating && note.id != selectedReleaseNoteForAction"><i class="fa fa-check"></i></span>
                                        <span v-if="releaseNoteUpdating && note.id == selectedReleaseNoteForAction"><i class="fa fa-spin fa-spinner"></i></span>
                                    </b-button>
                                </b-col>
                            </b-row>
                            <hr />
                            <b-row>
                                <b-col cols="12" sm="12" md="12">
                                    <p>
                                        <b-button v-on:click="addNewReleaseRow" variant="primary" :disabled="newNoteAddMode">
                                            <i class="fa fa-plus"></i>&nbsp;Add Note
                                        </b-button>
                                    </p>
                                </b-col>
                            </b-row>
                        </div>
                    </b-card>
                </b-col>
            </b-row>
        </div>
        <!-- confirm deletion modal -->
        <b-modal title="Confirm Deletion" class="modal-warning" v-model="showVersionDeleteModal" @ok="deleteReleaseData" ok-variant="warning">
            <p>
                Are you sure you wish to delete this desktop release version?
            </p>
            <p>
                Continuing will also delete all the release notes under this version.
            </p>
        </b-modal>
        <!-- confirm set release to live modal -->
        <b-modal title="Confirm Release Action" class="modal-warning" v-model="showSetVersionToLiveModal" @ok="setLiveVersionAgreed" ok-variant="warning">
            <p>
                Are you sure you wish to set this version as the current LIVE version?
            </p>
            <p>
                Continuing will affect how the release notes are displayed on the current desktop app.
            </p>
        </b-modal>
    </div>
</template>

<script>

import LoadingSpinner from '../../components/loadingSpinner/LoadingSpinner';
import { Switch as cSwitch } from '@coreui/vue';

export default {
  name: 'desktopReleases',
  components: {
      LoadingSpinner: LoadingSpinner,
      cSwitch,
  },
  data () {
    return {
      releases: [],
      release: {
        created_at: '',
        id: 0,
        is_current: false,
        release_notes: [],
        updated_at: '',
        version: ''
      },
      releasesLoaded: false,
      addMode: false,
      editMode: false,
      dataEntryMode: false,
      releaseSaveError: false,
      releaseSaveInProgress: false,
      releaseSaveSuccess: false,
      showVersionDeleteModal: false,
      showSetVersionToLiveModal: false,
      userObj: {},
      newNoteAddMode: false,
      releaseNoteUpdating: false,
      selectedReleaseNoteForAction: 0,
      selectedReleaseId: 0,
      
    }
  },
  created () {
    this.getDesktopReleases();
  },
  computed: {
    isUserReadOnly() {
        if (this.$data.userAuthLevel == 'Read Only') {
            return true;
        }
        else {
            return false;
        }
    },
    hasReleaseNotes() {
        if (this.$data.release.version === undefined || this.$data.release.version == null) {
            return false;
        }
        else {
            return this.$data.release.version.length > 0;
        }
    },
    allowSave() {
        return true;
    }
  },
  methods : {
    getDesktopReleases() {
        let headersObj = this.getHTTPHeaders();
        this.$http.get("desktopAppReleaseVersions", headersObj)
            .then((response) => {
                this.$data.releases = response.data.desktopAppVersions;
                this.$data.releasesLoaded = true;
            })
            .catch ((err) => {
                console.error(err);
                reject(err);
            });
    },
    getCurrentUser () {
        return new Promise((resolve, reject) => {
            let user = JSON.parse(localStorage.getItem('user'));
            if (user != null) {
                resolve(user);
            }
            else {
                reject();
            }
        });
    },
    getClassForRelease(release) {
        return release.is_current == "1" ? 'release-active' : 'release-disabled';
    },
    getClassForReleaseButton(release) {
        return release.is_current == "1" ? 'outline-success' : 'outline-danger';
    },
    getHTTPHeaders() {
        let userObj = JSON.parse(localStorage.getItem('user'));
        let headerConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': 'Bearer ' + userObj.token,
            }
        }
        return headerConfig;
    },
    exitAddMode() {
        this.resetReleaseInfo();
        this.$data.addMode = false;
        this.$data.editMode = false;
        this.$data.dataEntryMode = false;
        this.getDesktopReleases();
    },
    enterAddMode() {
        this.$data.addMode = true;
        this.$data.dataEntryMode = true;
        this.$data.editMode = false;
    },
    resetReleaseInfo() {
        this.$data.release = {
            created_at: '',
            id: 0,
            is_current: false,
            release_notes: [],
            updated_at: '',
            version: ''
        }
    },
    enterEditMode(selectedRelease) {
        this.resetReleaseInfo();
        this.$data.release = selectedRelease;
        this.$data.editMode = true;
        this.$data.dataEntryMode = true;
        this.$data.addMode = false;

        // get the release info and child data
        let headersObj = this.getHTTPHeaders();
        this.$http.get("desktopAppReleaseVersion/" + selectedRelease.id, headersObj)
            .then((response) => {
                this.$data.release = response.data.desktopAppVersionInfo.map((item) => {
                    if (item.is_current == 0) {
                        item.is_current = false;
                    }
                    else {
                        item.is_current = true;
                    }
                    return item;
                })[0];
                this.$data.releasesLoaded = true;
                console.log(this.$data.release);
            })
            .catch ((err) => {
                console.error(err);
                reject(err);
            });
    },
    clearAlerts() {
        this.$data.releaseSaveError = false;
        this.$data.releaseSaveInProgress = false;
    },
    async saveRelease() {
        this.clearAlerts();
        this.$data.releaseSaveInProgress = true;

        const response = await this.saveReleaseData();
        if (response.data.success == true) {
            this.$data.releaseSaveInProgress = false;
            this.$data.releaseSaveError = false;
            this.exitAddMode();
            this.getDesktopReleases();
        }
        else {  
            // data error
            this.$data.releaseSaveInProgress = false;
            this.$data.releaseSaveError = true;
        }
    },
    async saveReleaseAndAddNotes() {
        this.clearAlerts();
        this.$data.releaseSaveInProgress = true;

        const response = await this.saveReleaseData();
        if (response.data.success == true) {
            console.log(response);
            this.$data.releaseSaveInProgress = false;
            this.$data.releaseSaveError = false;
            this.enterEditMode(response.data.desktopAppVersion);
        }
        else {  
            // data error
            this.$data.releaseSaveInProgress = false;
            this.$data.releaseSaveError = true;
        }
    },
    async saveReleaseData() {
        return new Promise(async (resolve, reject) => {
            let headersObj = this.getHTTPHeaders();

            const formData = new FormData();
            let payload = {
                version: this.$data.release.version,
                is_current: this.$data.release.is_current ? 1 : 0,
            }

            for (let key in payload) {
                formData.append(key, payload[key])
            }

            let response = {};
            if (this.$data.addMode) {
                response = await this.$http.post('desktopAppReleaseVersions', formData, headersObj);
            }
            else {
                response = await this.$http.put('desktopAppReleaseVersions/' + this.$data.release.id, payload, headersObj);
            }
            
            if (response.data.success == true) {
                resolve(response);
            }
            else {
                reject(response);
            }
        });
    },
    async confirmSetLiveVersion(id) {
        this.$data.selectedReleaseId = id;
        this.$data.showSetVersionToLiveModal = true;
    },
    async setLiveVersionAgreed() {
        const response = await this.setLiveVersion(this.$data.selectedReleaseId);
        if (this.$data.editMode == true) { 
            this.enterEditMode(this.$data.release);
        }
    },
    async setLiveVersion(id) {
        return new Promise(async (resolve, reject) => {
            let headersObj = this.getHTTPHeaders();
            
            const formData = new FormData();
            let payload = {
                versionId: id,
            }

            for (let key in payload) {
                formData.append(key, payload[key])
            }

            const response = await this.$http.put('setVersionToLive/' + id, payload, headersObj);
            
            if (response.data.success == true) {
                this.getDesktopReleases();
                resolve(response);
            }
            else {
                reject(response);
            }
        });
        
    },
    deleteRelease() {
        this.$data.showVersionDeleteModal = true;
    },
    async deleteReleaseData() {
        let headersObj = this.getHTTPHeaders();

        this.$http.delete('desktopAppReleaseVersions/' + this.$data.release.id, headersObj)
        .then((response) => {
            this.$data.showVersionDeleteModal = false;
            this.exitAddMode();
        })
        .catch ((err) => {
            console.error(err);
        });
    },
    setIsCurrent(isCurrent) {
        this.$data.release.is_current = isCurrent;
    },
    setIsActive(isActive) {
        // get confirmation of active/inactive
        this.$data.newGroup.is_active = (isActive === '1' ? '0' : '1');
    },
    showReleaseNotes(releaseId) {
        console.log(releaseId);
        // show the release along with any notes
        let headersObj = this.getHTTPHeaders();
        this.$http.get("desktopAppReleaseVersion/" + releaseId, headersObj)
            .then((response) => {
                console.log(response);
                // this.$data.releases = response.data.desktopAppVersions;
                // this.$data.releasesLoaded = true;
            })
            .catch ((err) => {
                console.error(err);
                reject(err);
            });
    },
    addNewReleaseRow() {
        const newNote = {
            desktop_app_version_id: this.$data.release.id,
            id: -1,
            release_note: '',
            created_at: null,
            updated_at: null
        }
        this.$data.release.release_notes.push(newNote);
        this.$data.newNoteAddMode = true;
    },
    cancelNoteEntry(note) {
        this.$data.release.release_notes = this.$data.release.release_notes.filter((item) => {
            return item.id > 0;
        });
        this.$data.newNoteAddMode = false;
    },
    saveNewNote(note) {
        this.$data.selectedReleaseNoteForAction = note.id;
        this.$data.releaseNoteUpdating = true;
        let headersObj = this.getHTTPHeaders();

        const formData = new FormData();
        let payload = {
            desktop_app_version_id: this.$data.release.id,
            release_note: note.release_note,
        }

        for (let key in payload) {
          formData.append(key, payload[key])
        }

        this.$http.post('desktopAppReleaseNotes', formData, headersObj)
        .then((response) => {
            // clear out the new entry
            this.$data.release.release_notes = this.$data.release.release_notes.filter((item) => {
                return item.id > 0;
            });

            // now replace with the returned one from the backend
            this.$data.release.release_notes.push(response.data.releaseNote);

            this.$data.newNoteAddMode = false;
            this.$data.releaseNoteUpdating = false;
        })
        .catch ((err) => {
            console.error(err);
        });
        
    },
    deleteNote(note) {
        let headersObj = this.getHTTPHeaders();

        this.$http.delete('desktopAppReleaseNotes/' + note.id, headersObj)
        .then((response) => {
            this.enterEditMode(this.$data.release);
        })
        .catch ((err) => {
            console.error(err);
        });
    },
    updateNote(note) {
        this.$data.selectedReleaseNoteForAction = note.id;
        this.$data.releaseNoteUpdating = true;
        let headersObj = this.getHTTPHeaders();

        const formData = new FormData();
        let payload = {
            id: note.id,
            desktop_app_version_id: this.$data.release.id,
            release_note: note.release_note,
        }

        for (let key in payload) {
          formData.append(key, payload[key])
        }

        formData.append('_method', 'PUT');

        this.$http.post('desktopAppReleaseNotes/' + note.id, formData, headersObj)
        .then((response) => {
            this.$data.releaseNoteUpdating = false;
            this.enterEditMode(this.$data.release);
        })
        .catch ((err) => {
            console.error(err);
            this.$data.releaseNoteUpdating = false;
        });
    }
  }
}
</script>

<style scoped>

    .toggle-release-button {
        margin-top: 5px;
    }
    .release-active {
        color: #4dbd74!important;
    }
    .release-disabled {
        color: #f86c6b!important;
    }
    .output-row {
        margin-bottom: 8px;
    }
</style>